import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-plus-mobile",
  "use": "icon-plus-mobile-usage",
  "viewBox": "0 0 38 38",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 38 38\" fill=\"none\" id=\"icon-plus-mobile\">\n  <rect x=\"17.501\" width=\"2.99805\" height=\"38\" fill=\"#D9D9D9\" />\n  <rect y=\"20.499\" width=\"2.99805\" height=\"38\" transform=\"rotate(-90 0 20.499)\" fill=\"#D9D9D9\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol